import homepageBg from "@/assets/homepage-bg.jpg";
import smartparkLogo from "@/assets/smartpark-logo-black.png";
import { SUPPORT_EMAIL } from "@/lib/constants";

const NoAccessPage = () => {
  return (
    <div
      className="h-full w-full flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${homepageBg})` }}
    >
      <div className="bg-white rounded-2xl shadow-xl px-8 py-12 flex flex-col items-center max-w-md w-full mx-4 text-center">
        <img
          src={smartparkLogo}
          className="mb-8 h-16 w-auto object-contain"
          alt="SmartPark logo"
        />
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Welcome to SmartPark Ops
        </h2>
        <p className="text-gray-500 mb-6 leading-relaxed">
          Your account has been created, but you don't have access to any
          SmartParks yet. You'll need a link to claim your SmartPark(s).
        </p>
        <p className="text-gray-500 leading-relaxed">
          Please reach out to{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-blue hover:underline font-medium"
          >
            {SUPPORT_EMAIL}
          </a>{" "}
          and we'll get you set up.
        </p>
      </div>
    </div>
  );
};

export default NoAccessPage;
